import { render } from "./chart_tradingview.vue?vue&type=template&id=69125412&scoped=true"
const script = {}

import "./chart_tradingview.vue?vue&type=style&index=0&id=69125412&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69125412"]])

export default __exports__